import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const VERSIONS = [
  { ver: '1.20.4', proto: 765, title: 'Minecraft 1.20.4 (Protocol v765)', subRu: 'Рекомендованная актуальная версия', subEn: 'Recommended current version', rec: true },
  { ver: '1.20.1', proto: 763, title: 'Minecraft 1.20.1 (Protocol v763)', subRu: 'Широко распространенные сервера', subEn: 'Widely deployed servers', rec: false },
  { ver: '1.19.4', proto: 762, title: 'Minecraft 1.19.4 (Protocol v762)', subRu: 'Стабильное ядро Paper', subEn: 'Stable Paper core', rec: false },
  { ver: '1.16.5', proto: 754, title: 'Minecraft 1.16.5 (Protocol v754)', subRu: 'Netty стабильная архитектура', subEn: 'Netty stable architecture', rec: false },
  { ver: '1.12.2', proto: 340, title: 'Minecraft 1.12.2 (Protocol v340)', subRu: 'Классика анархических проектов', subEn: 'Anarchy servers classic', rec: false },
  { ver: '1.8.9', proto: 47, title: 'Minecraft 1.8.9 (Protocol v47)', subRu: 'PvP Legacy протокол', subEn: 'PvP Legacy protocol', rec: false },
];

const ATTACK_METHODS = {
  op: [
    { id: 'perm_bypass', title: 'Perm-Bypass Injection (Packet 0x17)', subRu: 'Попытка эскалации прав через переполнение матрицы пермишенов ядра', subEn: 'Privilege escalation attempt via kernel permission matrix overrun', rec: true },
    { id: 'nbt_payload', title: 'NBT Command-Block Payload', subRu: 'Эксплойт десериализации командного блока для инъекции команды /op', subEn: 'Command block deserialization exploit for /op command injection', rec: false },
    { id: 'bungee_uuid', title: 'BungeeCord UUID Spoofing', subRu: 'Подмена сессионного UUID через неэкранированный Bungee-шлюз', subEn: 'Session UUID spoofing via unescaped BungeeCord gateway', rec: false },
    { id: 'sign_overrun', title: 'Sign / Book Operator Buffer Overrun', subRu: 'Инъекция JSON-полезной нагрузки через событие редактирования табличек', subEn: 'JSON payload injection via sign editing packet event', rec: false },
  ],
  crash: [
    { id: 'window_click', title: 'Window Click Spam (Packet 0x0E)', subRu: 'Аномальные транзакции инвентаря для вызова переполнения стека вызовов', subEn: 'Anomalous inventory transactions triggering call stack overflow', rec: true },
    { id: 'nan_pos', title: 'NaN Position Infinity Overflow', subRu: 'Отправка бесконечных координат в сетевой поток для сбоя физического тика', subEn: 'Sending infinite coordinates to crash the physical server tick', rec: false },
    { id: 'chunk_flood', title: 'Chunk Overload Generation Flood', subRu: 'Массовый запрос генерации невалидных чанков за границей мира', subEn: 'Mass requests for generating invalid chunks beyond world border', rec: false },
    { id: 'netty_desync', title: 'Netty Channel Pipeline Desync', subRu: 'Рассинхронизация сетевых обработчиков для краша сокета Netty', subEn: 'Pipeline channel desynchronization for Netty socket crash', rec: false },
  ],
  account: [
    { id: 'authme_brute', title: 'AuthMe Multi-Thread Dictionary (8.2k)', subRu: 'Параллельный словарный подбор паролей через задержки ответа авторизации', subEn: 'Parallel dictionary password brute-forcing via auth response timings', rec: true },
    { id: 'fast_token', title: 'Fast-Auth Token Replay Bypass', subRu: 'Тестирование уязвимости повторного использования сессионных токенов', subEn: 'Testing session token replay vulnerabilities', rec: false },
    { id: 'session_hijack', title: 'Handshake Session Hijack Ping', subRu: 'Попытка перехвата и инъекции пакета приветствия игрока', subEn: 'Player greeting handshake intercept and injection attempt', rec: false },
    { id: 'rate_stress', title: 'Rate-Limit Delay Stress Benchmark', subRu: 'Оценка порогов блокировки IP и надежности защиты от брутфорса', subEn: 'Rate limit threshold assessment and anti-brute defense testing', rec: false },
  ],
};

const RANDOM_NICKNAMES = [
  'StormBot_47', 'ShadowOp_99', 'GhostPlayer_x', 'Cipher_MC',
  'ApexNexus_12', 'VortexRunner', 'ByteCracker', 'PhantomByte',
  'NettyReaper', 'PacketFlow_7', 'AlphaProbe_01', 'HyperBot_33'
];

const SKINS = [
  {
    id: 'steve',
    title: 'Стив (Steve Classic)',
    svg: (
      <svg className="skin-avatar-svg" viewBox="0 0 8 8">
        <rect x="0" y="0" width="8" height="2" fill="#4a3222" />
        <rect x="0" y="2" width="1" height="2" fill="#4a3222" />
        <rect x="7" y="2" width="1" height="2" fill="#4a3222" />
        <rect x="1" y="2" width="6" height="4" fill="#b37b56" />
        <rect x="0" y="4" width="8" height="2" fill="#b37b56" />
        <rect x="1" y="3" width="1" height="1" fill="#ffffff" />
        <rect x="2" y="3" width="1" height="1" fill="#2c5991" />
        <rect x="5" y="3" width="1" height="1" fill="#2c5991" />
        <rect x="6" y="3" width="1" height="1" fill="#ffffff" />
        <rect x="3" y="4" width="2" height="1" fill="#96603d" />
        <rect x="2" y="5" width="4" height="1" fill="#543323" />
        <rect x="0" y="6" width="8" height="2" fill="#4a3222" />
      </svg>
    ),
  },
  {
    id: 'alex',
    title: 'Алекс (Alex Slim)',
    svg: (
      <svg className="skin-avatar-svg" viewBox="0 0 8 8">
        <rect x="0" y="0" width="8" height="2" fill="#b8562d" />
        <rect x="0" y="2" width="2" height="3" fill="#b8562d" />
        <rect x="6" y="2" width="2" height="2" fill="#b8562d" />
        <rect x="2" y="2" width="4" height="4" fill="#e8ba99" />
        <rect x="2" y="3" width="1" height="1" fill="#ffffff" />
        <rect x="3" y="3" width="1" height="1" fill="#3c8c40" />
        <rect x="5" y="3" width="1" height="1" fill="#3c8c40" />
        <rect x="3" y="5" width="2" height="1" fill="#c47466" />
        <rect x="0" y="6" width="8" height="2" fill="#b8562d" />
      </svg>
    ),
  },
  {
    id: 'hacker',
    title: 'Хакер (Dark Visor)',
    svg: (
      <svg className="skin-avatar-svg" viewBox="0 0 8 8">
        <rect x="0" y="0" width="8" height="8" fill="#14141c" />
        <rect x="1" y="2" width="6" height="5" fill="#09090e" />
        <rect x="1" y="3" width="6" height="2" fill="#2ed573" />
        <rect x="2" y="3" width="1" height="2" fill="#ffffff" />
        <rect x="5" y="3" width="1" height="2" fill="#ffffff" />
      </svg>
    ),
  },
  {
    id: 'cyber',
    title: 'Кибер-агент (Cyber Purple/Cyan)',
    svg: (
      <svg className="skin-avatar-svg" viewBox="0 0 8 8">
        <rect x="0" y="0" width="8" height="8" fill="#1e182e" />
        <rect x="0" y="0" width="8" height="2" fill="#8b5cf6" />
        <rect x="1" y="3" width="6" height="2" fill="#00d2d3" />
        <rect x="3" y="3" width="2" height="2" fill="#ffffff" />
        <rect x="2" y="6" width="4" height="1" fill="#8b5cf6" />
      </svg>
    ),
  },
  {
    id: 'tuxedo',
    title: 'Смокинг (Agent 007)',
    svg: (
      <svg className="skin-avatar-svg" viewBox="0 0 8 8">
        <rect x="0" y="0" width="8" height="2" fill="#1b1b1f" />
        <rect x="1" y="2" width="6" height="4" fill="#d9a584" />
        <rect x="1" y="2" width="6" height="2" fill="#000000" />
        <rect x="2" y="2" width="1" height="1" fill="#ffffff" />
        <rect x="5" y="2" width="1" height="1" fill="#ffffff" />
        <rect x="0" y="6" width="8" height="2" fill="#0b0b0e" />
        <rect x="3" y="6" width="2" height="2" fill="#ffffff" />
        <rect x="3" y="7" width="2" height="1" fill="#ff4757" />
      </svg>
    ),
  },
];

const BotConfigCard = ({
  selectedClass,
  version,
  setVersion,
  username,
  setUsername,
  selectedMethod,
  setSelectedMethod,
  selectedSkin,
  setSelectedSkin,
  isDeploying,
  isDisabled,
  onToggleDeployment,
  onShowToast,
  onAddLog,
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const [versionDropdownOpen, setVersionDropdownOpen] = useState(false);
  const [methodDropdownOpen, setMethodDropdownOpen] = useState(false);

  const versionRef = useRef(null);
  const methodRef = useRef(null);

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (versionRef.current && !versionRef.current.contains(e.target)) {
        setVersionDropdownOpen(false);
      }
      if (methodRef.current && !methodRef.current.contains(e.target)) {
        setMethodDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const methodsList = ATTACK_METHODS[selectedClass] || ATTACK_METHODS.op;
  const currentMethodObj = methodsList.find((m) => m.id === selectedMethod) || methodsList[0];
  const currentVersionObj = VERSIONS.find((v) => v.ver === version) || VERSIONS[0];

  const handleGenerateNickname = () => {
    const idx = Math.floor(Math.random() * RANDOM_NICKNAMES.length);
    const suffix = Math.floor(Math.random() * 90 + 10);
    const baseName = RANDOM_NICKNAMES[idx].replace(/\d+$/, '');
    const newName = `${baseName}${suffix}`;
    setUsername(newName);
    onShowToast?.(isEn ? `Generated nickname: ${newName}` : `Сгенерировано имя: ${newName}`);
    onAddLog?.('bot', `Сгенерировано новое имя бота: ${newName}`);
  };

  const handleSelectVersion = (v) => {
    setVersion(v.ver);
    setVersionDropdownOpen(false);
    onShowToast?.(isEn ? `Version: ${v.ver}` : `Версия: ${v.ver}`);
    onAddLog?.('system', `Версия согласована: ${v.ver} (Protocol v${v.proto})`);
  };

  const handleSelectMethod = (m) => {
    setSelectedMethod(m.id);
    setMethodDropdownOpen(false);
    onShowToast?.(isEn ? 'Attack method updated' : 'Метод атаки обновлен');
    onAddLog?.('system', `Выбран метод атаки: ${m.title}`);
  };

  const handleSelectSkin = (skin) => {
    setSelectedSkin(skin.id);
    onShowToast?.(isEn ? `Skin: ${skin.title}` : `Скин: ${skin.title}`);
    onAddLog?.('bot', `Выбран скин: ${skin.title}`);
  };

  return (
    <section>
      <div className="section-mono-header">
        <div className="section-mono-title">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
          <span>{isEn ? 'SESSION CONFIGURATION' : 'КОНФИГУРАЦИЯ СЕССИИ'}</span>
        </div>
      </div>

      <div className="bot-config-card">
        <div className="config-grid">
          {/* 1. Minecraft Version Dropdown */}
          <div className="config-field-group" ref={versionRef}>
            <label className="field-label">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span>{isEn ? 'Minecraft Version' : 'Выбор версии Minecraft'}</span>
            </label>

            <div className={`custom-dropdown-wrap ${versionDropdownOpen ? 'open' : ''}`}>
              <button
                type="button"
                className="custom-dropdown-trigger"
                onClick={(e) => {
                  e.stopPropagation();
                  setMethodDropdownOpen(false);
                  setVersionDropdownOpen(!versionDropdownOpen);
                }}
              >
                <span className="dropdown-selected-name">{currentVersionObj.title}</span>
                <svg className="dropdown-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              {versionDropdownOpen && (
                <div className="custom-dropdown-menu">
                  {VERSIONS.map((v) => {
                    const isSelected = v.ver === version;
                    return (
                      <div
                        key={v.ver}
                        className={`dropdown-item ${isSelected ? 'selected' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectVersion(v);
                        }}
                      >
                        <div className="dropdown-item-info">
                          <div className="dropdown-item-title-row">
                            <span className="dropdown-item-title">Minecraft {v.ver}</span>
                            {v.rec && (
                              <span className="dropdown-badge-rec">
                                {isEn ? 'Recommended' : 'Рекомендовано'}
                              </span>
                            )}
                          </div>
                          <span className="dropdown-item-sub">
                            {isEn ? v.subEn : v.subRu} (v{v.proto})
                          </span>
                        </div>
                        <span className="dropdown-check-icon">
                          {isSelected && (
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6">
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* 2. Bot Username Input + Dice Generator */}
          <div className="config-field-group">
            <label className="field-label" htmlFor="botUsernameInput">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="5" />
                <path d="M20 21a8 8 0 1 0-16 0" />
              </svg>
              <span>{isEn ? 'Bot Username' : 'Имя пользователя бота'}</span>
            </label>

            <div className="username-field-box">
              <input
                type="text"
                id="botUsernameInput"
                value={username}
                autoComplete="off"
                spellCheck="false"
                onChange={(e) => setUsername(e.target.value)}
                placeholder="StormBot_47"
              />
              <button
                type="button"
                className="dice-generate-btn"
                onClick={handleGenerateNickname}
                title={isEn ? 'Generate random nickname' : 'Сгенерировать случайное имя'}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="4" />
                  <circle cx="8" cy="8" r="1.5" fill="currentColor" />
                  <circle cx="16" cy="8" r="1.5" fill="currentColor" />
                  <circle cx="12" cy="12" r="1.5" fill="currentColor" />
                  <circle cx="8" cy="16" r="1.5" fill="currentColor" />
                  <circle cx="16" cy="16" r="1.5" fill="currentColor" />
                </svg>
              </button>
            </div>
          </div>

          {/* 3. Dynamic Attack Method Dropdown */}
          <div className="config-field-group" ref={methodRef}>
            <label className="field-label">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              <span>{isEn ? 'Attack Method' : 'Метод атаки'}</span>
            </label>

            <div className={`custom-dropdown-wrap ${methodDropdownOpen ? 'open' : ''}`}>
              <button
                type="button"
                className="custom-dropdown-trigger"
                onClick={(e) => {
                  e.stopPropagation();
                  setVersionDropdownOpen(false);
                  setMethodDropdownOpen(!methodDropdownOpen);
                }}
              >
                <span className="dropdown-selected-name">{currentMethodObj.title}</span>
                <svg className="dropdown-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>

              {methodDropdownOpen && (
                <div className="custom-dropdown-menu">
                  {methodsList.map((m) => {
                    const isSelected = m.id === selectedMethod;
                    return (
                      <div
                        key={m.id}
                        className={`dropdown-item ${isSelected ? 'selected' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectMethod(m);
                        }}
                      >
                        <div className="dropdown-item-info">
                          <div className="dropdown-item-title-row">
                            <span className="dropdown-item-title">{m.title}</span>
                            {m.rec && (
                              <span className="dropdown-badge-rec">
                                {isEn ? 'Recommended' : 'Рекомендовано'}
                              </span>
                            )}
                          </div>
                          <span className="dropdown-item-sub">
                            {isEn ? m.subEn : m.subRu}
                          </span>
                        </div>
                        <span className="dropdown-check-icon">
                          {isSelected && (
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6">
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* 4. Bot Skin Selection Tiles */}
          <div className="config-field-group">
            <label className="field-label">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
              </svg>
              <span>{isEn ? 'Bot Skin' : 'Скин бота'}</span>
            </label>

            <div className="skin-tiles-row">
              {SKINS.map((skin) => {
                const isActive = selectedSkin === skin.id;
                return (
                  <button
                    key={skin.id}
                    type="button"
                    className={`skin-tile-btn ${isActive ? 'active' : ''}`}
                    onClick={() => handleSelectSkin(skin)}
                    title={skin.title}
                  >
                    {skin.svg}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Quick Stats and Main Action Button */}
        <div className="config-action-row">
          <div className="config-quick-stats">
            <div>
              {isEn ? 'Threads: ' : 'Потоки: '}
              <span className="config-stat-val">{isEn ? '10 threads' : '10 потоков'}</span>
            </div>
            <span>•</span>
            <div>
              {isEn ? 'Delay: ' : 'Задержка: '}
              <span className="config-stat-val">50 ms</span>
            </div>
            <span>•</span>
            <div>
              {isEn ? 'Tunnel: ' : 'Туннель: '}
              <span className="config-stat-val">{isEn ? 'Socks5 Direct' : 'Socks5 Прямой'}</span>
            </div>
          </div>

          <button
            type="button"
            className={`btn-deploy-main ${isDeploying ? 'running' : ''}`}
            onClick={onToggleDeployment}
          >
            <span className="btn-spinner-icon"></span>
            {!isDeploying && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
            )}
            <span>
              {isDeploying
                ? (isEn ? 'Stop Session' : 'Остановить сессию')
                : (isEn ? 'Deploy Bot' : 'Развернуть бота')}
            </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default BotConfigCard;
